import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import * as c from 'models/constants';

import {
	MagazinePageViewType1,
	MagazinePageViewType2,
	MagazinePageViewType3,
	MagazinePageViewType4,
	MagazinePageViewType5,
	MagazinePageViewType6,
	MagazinePageViewType7,
	MagazinePageViewType8,
	MagazinePageViewType9,
	MagazinePageViewType10,
	MagazinePageViewType11,
	MagazinePageViewType12,
	MagazinePageViewType13,
	MagazinePageViewType14,
	MagazinePageViewType15,
} from 'components/Magazine/Page/Sections';

interface IProps {
	section: IMagazinePageSection;
	siteCode?: string;
	activeTagHandleClick?: (activeTag: object) => void;
}

class MagazinePageSectionRenderer extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	private getComponent(section: IMagazinePageSection): JSX.Element {
		let component = null;
		switch (section.type) {
			case c.MAGAZINE_PAGE_SECTION_TYPE_1:
				component = <MagazinePageViewType1 section={section} />;
				break;
			case c.MAGAZINE_PAGE_SECTION_TYPE_2:
				component = <MagazinePageViewType2 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_3:
				component = <MagazinePageViewType3 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_4:
				component = <MagazinePageViewType4 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_5:
				component = <MagazinePageViewType5 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_6:
				component = <MagazinePageViewType6 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_7:
				component = <MagazinePageViewType7 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_8:
				component = <MagazinePageViewType8 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_9:
				component = <MagazinePageViewType9 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_10:
				component = <MagazinePageViewType10 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_11:
				component = <MagazinePageViewType11 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_12:
				component = <MagazinePageViewType12 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_13:
				component = <MagazinePageViewType13 section={section} />;
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_14:
				component = (
					<MagazinePageViewType14
						section={section}
						siteCode={this.props.siteCode}
						activeTagHandleClick={this.props.activeTagHandleClick}
					/>
				);
				break;

			case c.MAGAZINE_PAGE_SECTION_TYPE_15:
				component = <MagazinePageViewType15 section={section} />;
				break;

			default:
				component = null;
		}

		return component;
	}

	public render() {
		const { section } = this.props;

		const component = this.getComponent(section);

		return <>{component}</>;
	}
}

export { MagazinePageSectionRenderer };
